import { api } from "api/api";
import {
    BookAppointmentOnlineOptionItemModel
} from "models/BookAppointmentOnlineModel/BookAppointmentOnlineOptionItemModel";

export interface ItemDTO {
    id: string;
    name: string;
}
export default async function getDoctorList(appointmentTypeId?: string): Promise<BookAppointmentOnlineOptionItemModel[]> {
    const url = 'api/public/book/appointment/online/doctor/list';

    const response = await api.get(url, {
            params: { appointmentTypeId }
        }
    );
    return response.data.data.map(
        (item: ItemDTO) => {
            return new BookAppointmentOnlineOptionItemModel(item);
        }
    )
};
